export default "__VITE_ASSET__TEbzsrhC__"